import React from 'react';
import { getFeatureStatus } from '@/config/featureStatus';

const TONES = {
  live: {
    background: 'rgba(46,125,50,0.1)',
    border: 'rgba(46,125,50,0.24)',
    color: '#2E7D32',
  },
  beta: {
    background: 'rgba(184,134,11,0.12)',
    border: 'rgba(184,134,11,0.28)',
    color: '#8A6508',
  },
  comingSoon: {
    background: 'rgba(47,62,70,0.08)',
    border: 'rgba(47,62,70,0.18)',
    color: '#2F3E46',
  },
  internal: {
    background: 'rgba(140,134,128,0.12)',
    border: 'rgba(140,134,128,0.22)',
    color: '#5F5A55',
  },
};

const FeatureBadge = ({ feature, label, compact = false, className = '' }) => {
  const status = getFeatureStatus(feature);
  const tone = TONES[status.tone] || TONES.comingSoon;

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-ui uppercase ${className}`}
      title={status.description}
      style={{
        background: tone.background,
        border: `1px solid ${tone.border}`,
        color: tone.color,
        fontSize: compact ? 8 : 9,
        lineHeight: 1,
        letterSpacing: '0.14em',
        padding: compact ? '4px 6px' : '5px 8px',
        whiteSpace: 'nowrap',
      }}
    >
      {label || status.label}
    </span>
  );
};

export default FeatureBadge;
